export const DEFAULT_HIDE_DURATION = 3.5 * 1000;
export const DEFAULT_TOAST_LIMIT = 3;
